module.exports = __webpack_public_path__ + "img/13.f5769b32.png";